module.exports = __webpack_public_path__ + "img/water.0dea0a1a.png";